import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Row, Form, FormGroup, Label, Input } from "reactstrap";
import PageTitle from "../../layouts/PageTitle";
import { createAttributeFunc } from "../../../store/custom-actions/attributes-actions/CreateAttributeSlicer";
import SubmitButton from '../../components/ui/SubmitButton';

const NewAttributePage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [attributeName, setAttributeName] = useState("");
  const { loading: submitLoading } = useSelector((state) => state.createAttributeSlicer);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: attributeName
      }
      const res = await dispatch(createAttributeFunc({ data: payload })).unwrap();
      
      if (res?.attribute?.id) {
        navigate(`/edit-attribute/${res.attribute.id}`);
      } else {
        navigate("/attributes");
      }
    } catch (error) {
      console.error("Error creating attribute:", error);
    }
  };

  return (
    <>
      <PageTitle motherMenu={"Attributes"} activeMenu={"New Attribute"}  motherMenuPath="/attributes"/>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <h4 className="card-title">{t("Add New Attribute")}</h4>
            </CardHeader>
            <CardBody>
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label for="attributeName">{t("Attribute Name")}</Label>
                  <Input
                    type="text"
                    id="attributeName"
                    value={attributeName}
                    onChange={(e) => setAttributeName(e.target.value)}
                    required
                  />
                </FormGroup>

                <div className="text-end">
                  <SubmitButton
                    isLoading={submitLoading}
                  />
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default NewAttributePage;
